
<template>
  <div id="page-user-view">
    <div id="user-data">
      <vx-card  class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="photoURL" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <!-- <tr>
                <td class="font-semibold">Username</td>
                <td>{{ activeUserInfo.username }}</td>
              </tr> -->
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ getUserInfo.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ getUserInfo.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <!-- <tr>
                <td class="font-semibold">Status</td>
                <td>{{ activeUserInfo.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Role</td>
                <td>{{ activeUserInfo.role }}</td>
              </tr> -->
              <tr>
                <td class="font-semibold">참여 수업</td>
                <td>{{ activeWorkspace.title }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <!-- <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-user-edit', params: { userId: $route.params.userId }}">Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Delete</vs-button> -->
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="출결 현황" class="mb-base">
            <span v-if="getInsightUser.total_count == 0">출결 정보가 없습니다</span>
            <vue-apex-charts  autoresize type="pie" height="350" :options="attendPieChart.chartOptions" :series="attendPieChart.series"></vue-apex-charts>
            <!-- <e-charts autoresize :options="pie" ref="pie" auto-resize /> -->
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="과제 현황" class="mb-base">
            <span v-if="submitVal.labels.length == 0">과제 결과가 없습니다</span>
            <vue-apex-charts autoresize type="donut" height="350" :options="submitPieChart.chartOptions" :series="submitPieChart.series"></vue-apex-charts>
          </vx-card>
        </div>
      </div>

      <!-- Permissions -->
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="Edit2Icon" class="mr-2" />
              <span class="font-medium text-lg leading-none">시험 성적</span>
            </div>
            <!-- <vs-divider /> -->
          </div>
        </div>

        <div class="block overflow-x-auto">
          <span v-if="columnDefs.length == 0">온라인 테스트 결과가 없습니다</span>
          <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="userData"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl">
          </ag-grid-vue>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// import ECharts from 'vue-echarts/components/ECharts'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/pie'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import InsightTestScore from "./cell-renderer/InsightTestScore.vue"
import InsightSubmitScore from "./cell-renderer/InsightSubmitScore.vue"
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData.js'


export default {
    name: 'InsightUser',
    components: {
      AgGridVue,
      InsightTestScore,
      InsightSubmitScore,
      VueApexCharts,
    },
    data() {
      return {
        user_data: null,
        user_not_found: false,
        apexChatData: apexChatData,
        themeColors: ['#28C76F', '#EA5455', '#FF9F43', '#7367F0', '#1E1E1E'],
        attendPieChart:null,
        submitPieChart:null,
        columnDefs:[],
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        gridApi: null,
        userData:[],
        gridOptions: {},
        components: {
          InsightTestScore,
          InsightSubmitScore,
        },
        submitVal: {labels:[], series:[]},
        photoURL:''
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      paginationPageSize() {
        if(this.gridApi) return this.gridApi.paginationGetPageSize()
        else return 10
      },
      getInsightUser(){
        return this.$store.getters['insight/getInsightUser'](this.$route.params.userId)
      },
      getUserInfo(){
        return this.$store.getters['space/getMemberInfo'](this.$route.params.userId)
      },
      testResults(){
        return this.$store.state.insight.testResults
      },
      currentPage: {
        get() {
          if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      },
    },
    mounted () {
      this.gridApi = this.gridOptions.api
    },
    methods: {

    },
    beforeDestroy() {
      // this.$store.unregisterModule('insight')
      // moduleInsight.isRegistered = false
    },
    created() {      
      var user = this.getInsightUser
      this.userData.push(user)
      this.photoURL = require("@/assets/images/portrait/small/" + this.getUserInfo.photo_url)
      var series = [user.attend_count, user.miss_count, user.late_count]
      this.attendPieChart = {series:series, chartOptions: { labels: ['출석', '결석', '지각'],  colors: this.themeColors, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}

      this.submitVal = {labels:[], series:[]}
      for (var i in user.submit){
        var val = null
        if(user.submit[i] == null){
          val = '평가 없음'
        } else{
          val = user.submit[i]
        }
        var index = this.submitVal.labels.findIndex((contact)=> contact == val)
        if(index == -1) {
          this.submitVal.labels.push(val)
          this.submitVal.series.push(1)
        }else{
          this.submitVal.series[index] = this.submitVal.series[index] + 1
        }
      }
      this.submitPieChart = {series:this.submitVal.series, chartOptions: { labels: this.submitVal.labels,  colors: this.themeColors, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}

      for(var j in this.testResults){
        // this.columnDefs.push({headerName:this.testResults[j].online_test.title, field: 'test'+j, width: 101, cellRendererFramework: 'InsightTestScore'})
        this.columnDefs.push({headerName:this.testResults[j].online_test.title, field: 'test'+j, width: 101})

      }
    }
  }
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }
@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
